var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('h6',{domProps:{"textContent":_vm._s(_vm.$ml.get('contacts'))}},[_vm._v("Contatos")]),_c('hr'),_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" E-mail: "),_c('b',[_vm._v("contato@bughunt.com.br")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col justify-content-center d-flex"})])
}]

export { render, staticRenderFns }